/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, May 11th 2023, 5:00:39 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { AITaskInstructionManyToOnePicker } from "service-builder/components/ai-workers";

interface AITaskFieldsProps {
  aiTaskInstructionId: TaskTemplate["ai_task_instruction"];
}

export const AITaskSettings = ({ aiTaskInstructionId }: AITaskFieldsProps) => {
  return (
    <AITaskInstructionManyToOnePicker<TaskTemplate>
      schema_field_key="ai_task_instruction"
      label="AI Task Instruction"
    />
  );
};
